export default {
  name: 'MusicListItemTop',

  setup(props) {
    console.log(props);

    const changeCount = num => num >= 100000000 ? (num / 100000000).toFixed(1) + '亿' : (num / 10000).toFixed(1) + '万';

    return {
      changeCount
    };
  },

  props: ['itemPlayList']
};